export const config = {
        apiKey: "AIzaSyAwml91s9GRv_TIoqLroYu_h7THnMjOY4I",
        authDomain: "owlfuse-app.firebaseapp.com",
        databaseURL: "https://owlfuse-app.firebaseio.com",
        projectId: "owlfuse-app",
        storageBucket: "owlfuse-app.appspot.com",
        messagingSenderId: "619966969857",
        appId: "1:619966969857:web:5b0cbf46778fd34ba0e800",
        measurementId: "G-EK9BHCG1BD"
}